$(function () {
  if ($('.megamenu').length) {
    var $body = $('body');
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 69) {
        $body.addClass('scrolling');
        if (scroll > $body.find('.transparent-megamenu-hero-block').outerHeight()) {
          $body.addClass('scrolled-after-hero');
        }
        else {
          $body.removeClass('scrolled-after-hero');
        }
      }
      else {
        $body.removeClass('scrolling');
        $body.removeClass('scrolled-after-hero');
      }
    });
  }
});